import { Component, Prop, Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

@Component
export default class PaymentDetails extends Vue {
    @Prop()
    orderCode: string;

    @Prop()
    expirationDate: string;

    get formattedExpirationDate() {
        return dayjs.utc(this.expirationDate).local().format('DD/MM/YYYY, HH:mm');
    }
}
